'use client';

import { usePathname } from 'next/navigation';

import Footer from '../landing/Footer';

export default function ConditionalFooter() {
  const pathname = usePathname();
  const isJoinPage = pathname.startsWith('/join');

  if (isJoinPage) {
    return null;
  }

  return <Footer />;
}
